import _from from './from';
import _to from './to';
import type { Types } from './types';

export class CoreMap {
  static to   = _to;
  static from = _from;
}

export { Types as CoreTypes };

export * from './interfaces';